import { state } from './state'
import { getters } from './getters'
import { mutations } from './mutations'

export default {
	state,
	getters,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Loader/index.js